import React from 'react';

import { Grid, Checkbox } from '@material-ui/core';

import useDataManagementEffects from './hooks';
import LabelsTable from './LabelsTable';
import PredictionsViewDialog from './PredictionsViewDialog';
import SamplesRelabelDialog from './SamplesRelabelDialog';
import DeletePredictionsDialog from './DeletePredictionsDialog';
import { Select } from '../../components';
import PredictionsFilterByDate from './PredictionsFilterByDate/PredictionsFilterByDate';
import PredictionsFilterByImageSource from './PredictionsFilterByImageSource/PredictionsFilterByImageSource';
import PredictionsFilterByCaptureTrigger from './PredictionsFilterByCaptureTrigger/PredictionsFilterByCaptureTrigger';
import PredictionsFilterByFamily from './PredictionsFilterByFamily/PredictionsFilterByFamily';

const DataManagement = () => {
  const {
    classes,
    loadingAgentsData,
    loadingPredictions,
    configOptions,
    currentConfig,
    totalSamples,
    totalLabels,
    totalSamplesWithinDates,
    totalLabelsWithinDates,
    rows,
    fromDate,
    toDate,
    predictionsToView,
    predictionsList,
    predictionsToDeleteSize,
    samplesToRelabel,
    lookupTable,
    allSamplesData,
    flags,
    updateFlags,
    onDeleteSamples,
    closeDeleteDialog,
    onViewLabelSamples,
    onRelabelSample,
    onRelabelSamples,
    onRelabelSamplesWithinDates,
    onUpdateSamples,
    onViewSamplesWithinDates,
    closePredictionsViewDialog,
    onDeleteSamplesWithinDates,
    onDeleteSamplesByIds,
    handleDateChange,
    onDeleteLabelSamples,
    onConfigChange,
    onMakePredictionByImage,
    clearPredictionsList,
    closeSamplesRelabelDialog,
  } = useDataManagementEffects();
  return (
    <Grid container spacing={3}>
      <PredictionsViewDialog
        classes={classes}
        predictionsToView={predictionsToView}
        predictionsList={predictionsList}
        loading={loadingPredictions}
        onDeleteSamples={onDeleteSamplesByIds}
        onMakePredictionByImage={onMakePredictionByImage}
        clearPredictionsList={clearPredictionsList}
        handleClose={closePredictionsViewDialog}
        onRelabelSample={onRelabelSample}
        currentConfig={currentConfig}
      />
      <DeletePredictionsDialog
        classes={classes}
        predictionsToDeleteSize={predictionsToDeleteSize}
        onConfirm={onDeleteSamples}
        handleClose={closeDeleteDialog}
      />
      <SamplesRelabelDialog
        classes={classes}
        samplesToRelabel={samplesToRelabel}
        onRelabelSamples={onUpdateSamples}
        handleClose={closeSamplesRelabelDialog}
      />
      <Grid item xs={6}>
        <Grid className={classes.withSpacing}>
          <Grid className={classes.labelWithValue}>
            Use Local Data Manager:
            <Checkbox
              defaultChecked={flags?.local}
              checked={flags?.local}
              value={flags?.local}
              onChange={(ev) => {
                updateFlags({ local: ev.target.checked });
              }}
            />
          </Grid>
          <Grid className={classes.labelWithValue}>
            Total samples:
            <span className={classes.number}>{totalSamples}</span>
          </Grid>
          <Grid className={classes.labelWithValue}>
            Total labels:
            <span className={classes.number}>{totalLabels}</span>
          </Grid>
        </Grid>
        <PredictionsFilterByDate
          classes={classes}
          loading={loadingAgentsData}
          fromDate={fromDate}
          toDate={toDate}
          totalSamplesWithinDates={totalSamplesWithinDates}
          totalLabelsWithinDates={totalLabelsWithinDates}
          onDelete={onDeleteSamplesWithinDates}
          onRelabelSamples={onRelabelSamplesWithinDates}
          handleDateChange={handleDateChange}
          onViewSamples={onViewSamplesWithinDates}
        />
        <PredictionsFilterByFamily
          classes={classes}
          loading={loadingAgentsData}
          onDelete={onDeleteSamplesWithinDates}
          onRelabelSamples={onRelabelSamplesWithinDates}
          handleDateChange={handleDateChange}
          onViewSamples={onViewSamplesWithinDates}
          allSamplesData={allSamplesData}
        />
        <PredictionsFilterByCaptureTrigger
          classes={classes}
          loading={loadingAgentsData}
          onDelete={onDeleteSamplesWithinDates}
          onRelabelSamples={onRelabelSamplesWithinDates}
          handleDateChange={handleDateChange}
          onViewSamples={onViewSamplesWithinDates}
          allSamplesData={allSamplesData}
        />
        <PredictionsFilterByImageSource
          classes={classes}
          loading={loadingAgentsData}
          onDelete={onDeleteSamplesWithinDates}
          onRelabelSamples={onRelabelSamplesWithinDates}
          handleDateChange={handleDateChange}
          onViewSamples={onViewSamplesWithinDates}
          allSamplesData={allSamplesData}
        />

        <Select
          options={configOptions}
          currentOptionIndex={currentConfig}
          onSelect={onConfigChange}
          label="Config"
          className={classes.select}
        />
      </Grid>
      <Grid item xs={6}>
        <LabelsTable
          classes={classes}
          loading={loadingAgentsData}
          rows={rows}
          lookupTable={lookupTable}
          onDeleteLabelSamples={onDeleteLabelSamples}
          onViewLabelSamples={onViewLabelSamples}
          onRelabelSample={onRelabelSamples}
        />
      </Grid>
    </Grid>
  );
};

export default DataManagement;
